import { Sparkle } from '@phosphor-icons/react';
import type { FC } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import type { QuickHelpMessage } from '@providers/QuickHelp/types';
import AgentThinkingIndicator from './AgentThinkingIndicator';
import styles from './AgentMessageBubble.module.css';

interface Props {
    message: QuickHelpMessage;
    /** Show "Reparo AI" anchor — true for the first assistant message in a turn */
    showAnchor?: boolean;
    /** Add bottom spacer — true when this is the last message before a role switch */
    isTurnEnd?: boolean;
    /** Current tool/processing status from the agent */
    statusText?: string;
}

const AgentMessageBubble: FC<Props> = ({
    message,
    showAnchor = false,
    isTurnEnd = false,
    statusText,
}) => {
    const isUser = message.role === 'user';

    if (message.isStreaming && !message.content) {
        return <AgentThinkingIndicator statusText={statusText} />;
    }

    if (isUser) {
        return (
            <>
                <div className={styles.userWrap}>
                    <div className={styles.userBubble}>{message.content}</div>
                </div>
                {isTurnEnd && <div className={styles.turnSpacer} />}
            </>
        );
    }

    return (
        <>
            <div className={styles.assistantWrap}>
                <div className={styles.assistantCard}>
                    {showAnchor && (
                        <div className={styles.anchorWrap}>
                            <Sparkle size={10} weight="fill" color="#6366f1" />
                            <span className={styles.anchorLabel}>Reparo AI</span>
                        </div>
                    )}
                    <div className={styles.markdownRoot}>
                        <ReactMarkdown remarkPlugins={[remarkGfm]}>
                            {message.content}
                        </ReactMarkdown>
                        {message.isStreaming && (
                            <span className={styles.streamingCursor} />
                        )}
                    </div>
                </div>
            </div>
            {isTurnEnd && <div className={styles.turnSpacer} />}
        </>
    );
};

export default AgentMessageBubble;
